module.exports = __webpack_public_path__ + "img/bbva-MODO-mobile.3648a785.svg";